/**
 * Custom filter created by a user.
 */
export interface Filter
{
    /**
     * Id of the filter.
     */
    id: string;

    /**
     * Name of the filter.
     */
    name: string;

    /**
     * Username of the user who created the filter.
     */
    createdBy: string;

    /**
     * Data category.
     */
    category: string;

    /**
     * State string.
     */
    state: string;

    /**
     * Date when the filter is created.
     */
    createdOn: Date;

    /**
     * Scope of the filter.
     */
    scope: Scope;

    /**
     * Organization to apply the filter
     */
    organization: number;

    /**
     * Screen where the filter will be applied
     */
    screen: string;

    /**
     * Columns
     */
    columns: string;
}

export enum Scope
{
    global,
    group,
    user
}
